module.exports = __webpack_public_path__ + "static/ps3-d51b8ba02f860dffe784d8ef175a7d25.jpg";